import $ from 'jquery';

const timelineProgressLine = () => {
	const el = {
		timeline: '.timeline',
		line: '.timeline-line',
		progress: '.timeline-progress',
		item: '.timeline-item',
		dot: '.timeline-dot',
	};

	if ($(el.timeline).length === 0) return;

	let ticking = false;

	const init = () => {
		update();
		bindEvent();
		bindResizeObserver();
	};

	const update = () => {
		updateLine();
		updateProgress();
	};

	const updateLine = () => {
		const $timeline = $(el.timeline);
		const $line = $(el.line);
		const $items = $(el.item);

		if ($line.length === 0 || $items.length === 0) return;

		const $firstDot = $items.first().find(el.dot);
		const $lastDot = $items.last().find(el.dot);

		if ($firstDot.length === 0 || $lastDot.length === 0) return;

		const timelineRect = $timeline.get(0).getBoundingClientRect();
		const firstDotRect = $firstDot.get(0).getBoundingClientRect();
		const lastDotRect = $lastDot.get(0).getBoundingClientRect();

		const firstDotCenter =
			firstDotRect.top + firstDotRect.height / 2 - timelineRect.top;
		const lastDotCenter =
			lastDotRect.top + lastDotRect.height / 2 - timelineRect.top;

		$line.css({
			top: `${firstDotCenter}px`,
			height: `${lastDotCenter - firstDotCenter}px`,
			bottom: 'auto',
		});
	};

	const updateProgress = () => {
		const $progress = $(el.progress);
		const $items = $(el.item);

		if ($progress.length === 0 || $items.length === 0) return;

		const $firstDot = $items.first().find(el.dot);
		const $lastDot = $items.last().find(el.dot);

		if ($firstDot.length === 0 || $lastDot.length === 0) return;

		const firstDotRect = $firstDot.get(0).getBoundingClientRect();
		const lastDotRect = $lastDot.get(0).getBoundingClientRect();

		const firstDotY = firstDotRect.top + firstDotRect.height / 2;
		const lastDotY = lastDotRect.top + lastDotRect.height / 2;

		const viewportCenter = window.innerHeight / 2;
		const totalDistance = lastDotY - firstDotY;

		if (totalDistance <= 0) return;

		const currentDistance = viewportCenter - firstDotY;
		let progressValue = currentDistance / totalDistance;
		progressValue = Math.max(0, Math.min(1, progressValue));

		$progress.css('transform', `scaleY(${progressValue})`);
	};

	const bindEvent = () => {
		$(window).on('load', update);
		$(window).on('resize', update);

		$(window).on('scroll', () => {
			if (!ticking) {
				window.requestAnimationFrame(() => {
					updateProgress();
					ticking = false;
				});

				ticking = true;
			}
		});
	};

	const bindResizeObserver = () => {
		if (typeof ResizeObserver === 'undefined') return;

		const timeline = $(el.timeline).get(0);

		if (!timeline) return;

		const observer = new ResizeObserver(() => {
			update();
		});

		observer.observe(timeline);
	};

	init();
};

try {
	timelineProgressLine();
} catch (error) {
	console.error('timelineProgressLine', error);
}
